module.exports = __webpack_public_path__ + "static/media/logoOUPsolus_white.449b2ade.png";